export default __webpack_public_path__ + "static/media/roughness.14595fc8.svg";